import i18n from '../locales/index'
import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead
} from '@/libs/util'
import Vue from 'vue'
import modules from './modules'
import router from '@/router'
import routers from '@/router/routers'
import config from '@/config'
import Vuex from 'vuex'

Vue.use(Vuex)

const { homeName } = config

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter((item) => {
    return !routeEqual(item, route)
  })
  router.push(nextRoute)
}

const state = {
  breadCrumbList: [],
  tagNavList: [],
  homeRoute: {},
  local: localRead('local'),
  hasReadErrorPage: false,
  messageCount: 10
}

const getters = {
  menuList: (state, getters, rootState) => {
    return getMenuByRouter(routers, rootState.editor.me.access);
  }
}

const mutations = {
  setBreadCrumb (state, route) {
    state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
  },
  setHomeRoute (state, routes) {
    state.homeRoute = getHomeRoute(routes, homeName)
  },
  setTagNavList (state, list) {
    let tagList = []
    if (list) {
      tagList = [...list]
    } else tagList = getTagNavListFromLocalstorage() || []
    if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
    const homeTagIndex = tagList.findIndex((item) => item.name === homeName)
    if (homeTagIndex > 0) {
      const homeTag = tagList.splice(homeTagIndex, 1)[0]
      tagList.unshift(homeTag)
    }
    state.tagNavList = tagList
    setTagNavListInLocalstorage([...tagList])
  },
  closeTag (state, route) {
    const tag = state.tagNavList.filter((item) => routeEqual(item, route))
    route = tag[0] ? tag[0] : null
    if (!route) return
    closePage(state, route)
  },
  addTag (state, { route, type = 'unshift' }) {
    const router = getRouteTitleHandled(route)
    if (!routeHasExist(state.tagNavList, router)) {
      if (type === 'push') state.tagNavList.push(router)
      else {
        if (router.name === homeName) state.tagNavList.unshift(router)
        else state.tagNavList.splice(1, 0, router)
      }
      setTagNavListInLocalstorage([...state.tagNavList])
    }
  },
  setLocal (state, lang) {
    localSave('local', lang)
    state.local = lang
  },
  setHasReadErrorLoggerStatus (state, status = true) {
    state.hasReadErrorPage = status
  }
}

const actions = {}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules
})

export default store
